// 使用方法
// 已经绑定到Vue原型上
// this.$toast({
//   message: '操作成功', // 显示提示文字 可选
//   iconName: 'vip', // 图标 可选
//   position: 'bottom',// 位置信息 可选
//   duration: 3000 // 显示时间
// })
// 或者this.$toast('message')
import Vue from 'vue';
import toast from './toast.vue';
import { Consts } from '@/libs/interfaces';

const ToastConstructor = Vue.extend(toast);

const toastTool = [];
const getIntance = () => {
  if (toastTool.length > 0) {
    const intance = toastTool[0];
    return intance;
  }
  return new ToastConstructor({
    el: document.createElement('div'),
  });
};
const removeDom = (e) => {
  if (e.target.parentNode) {
    e.target.parentNode.removeChild(e.target);
  }
};
ToastConstructor.prototype.close = function () {
  // console.log(this)
  this.visible = false;
  this.closed = true;
  this.$el.addEventListener('transitionend', removeDom);
  toastTool.push(this);
  // console.log(toastTool)
};
const Toast = (options = {}) => {
  if ((options.message || options) === '点歌成功') {
    Vue.$fetchLoading.open(Consts.ORDER_SUCCESS);
    return;
  }
  const intance = getIntance();
  if (options.parentDom) {
    options.parentDom.appendChild(intance.$el);
  } else {
    document.body.appendChild(intance.$el);
  }
  intance.iconPath = options.iconPath || require('../../../imgs/succ.png')
  intance.toastCss = options.toastCss || {}
  intance.toastTxt = options.toastTxt || ''
  intance.message = typeof options !== 'object' ? options : options.message || '网络异常';
  intance.tip = typeof options !== 'object' ? '' : options.tip;
  intance.duration = options.duration || 1500;
  intance.className = options.className || '';
  intance.iconName = options.iconName || '';
  intance.position = options.position || '';
  intance.type = options.type || '';
  intance.toastSvg = options.toastSvg || 'toast-svg';
  intance.toastImg = options.toastImg || '';
  intance.imgWidth = options.imgWidth || '';
  intance.callback = options.callback;
  intance.closeCallback = options.closeCallback;
  intance.toastStyle = options.toastStyle
  intance.showModal = options.showModal
  intance.closed = false;
  intance.$el.removeEventListener('transitionend', removeDom);
  clearTimeout(intance.timer);
  Vue.nextTick(() => {
    intance.visible = true;
    if (intance.duration) {
      intance.timer = setTimeout(() => {
        if (intance.closed) {
          return false;
        }
        intance.close();
        if (intance.closeCallback) {
          intance.closeCallback()
        }
      }, intance.duration);
    }
  });
  return intance;
};

Toast.close = () => {
  const intance = getIntance();
  if (!intance) return;
  intance.close();
};

export default Toast;
